module.exports = __webpack_public_path__ + "img/1-4.5501280d.png";